<template>
    <multiselect
            v-model="subscribers"
            :close-on-select="false"
            :clear-on-select="true"
            :preserve-search="true"
            :options="users"
            :multiple="true"
            track-by="id"
            placeholder="Who will be notified"
            label="full_name"
            @input="$emit('submitting', true)"
    />
</template>

<script>
    import Subscribers from '../mixins/Subscribers'

    export default {
        mixins: [Subscribers],

        watch: {
            subscribers: {
                deep: true,
                handler() {
                    if (!this.dataLoaded) return

                    this.$emit('input', this.subscribers)
                }
            }
        },

        mounted() {
            this.$emit('input', this.subscribers)
        }
    }
</script>
